const sanitizeWeightInput = (value) => {
  if (value === undefined || value === null) {
    return "";
  }
  const stringValue = String(value);
  const matches = stringValue.match(/^(\d+\.?\d*|\d*\.?\d+)$/);
  if (matches) {
    return matches[0];
  }
  const digitsAndDot = stringValue.replace(/[^0-9.]/g, "");
  const firstDotIndex = digitsAndDot.indexOf(".");
  if (firstDotIndex === -1) {
    return digitsAndDot;
  }
  return (
    digitsAndDot.slice(0, firstDotIndex + 1) +
    digitsAndDot.slice(firstDotIndex + 1).replace(/\./g, "")
  );
};

const isWeightQuestion = (question, meaning) => {
  const text = `${question || ""} ${meaning || ""}`.toLowerCase();
  return text.includes("weight");
};

export {sanitizeWeightInput, isWeightQuestion};
